export default __webpack_public_path__ + "static/instagram-f7b3dff34fba7bf43d83022425cb2ef3.png";